import { render, staticRenderFns } from "./webMessageReport.vue?vue&type=template&id=12370f93&"
import script from "./webMessageReport.vue?vue&type=script&lang=js&"
export * from "./webMessageReport.vue?vue&type=script&lang=js&"
import style0 from "./webMessageReport.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports